module.exports = __webpack_public_path__ + "static/media/service-2.d550ec6e.png";